import { Component, OnInit, ElementRef, Input } from '@angular/core';
import { ServiceStackService } from 'app/service-stack-service/service-stack-service.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

declare let window: any;

@Component({
    selector: 'clearwave-grid',
    templateUrl: 'clearwave-grid.component.html',
    styleUrls: ['clearwave-grid.component.css'],
    providers: []
})
export class ClearWaveGridComponent implements OnInit {
    @Input() options: any;

    private grid = new window.Clearwave.Grid();

    private canCreate: Boolean = true; // Needs to be linked to security resource
    private canRead: Boolean = true; // Needs to be linked to security resource
    private canUpdate: Boolean = true; // Needs to be linked to security resource
    private canDelete: Boolean = true; // Needs to be linked to security resource

    public hideHeader: Boolean;
    public hideFooter: Boolean;

    private batchMode: Boolean = false;
    public gridFormVisible: Boolean = false;
    public filterBarVisible: Boolean = false;
    public searchModalVisible: Boolean = false;
    private currentSorter: Array<any> = [];

    private selectedRows: Array<any> = [];
    private editRow = null;

    private groups: Array<any> = [];

    constructor(
        private _serviceStackService: ServiceStackService,
        private _er: ElementRef,
        private _toastr: ToastsManager
    ) { }

    ngOnInit() {
        this.startGrid();

        let cWG = this;

        this.grid.slickGrid.onSort.subscribe((e, args) => {
            cWG.currentSorter = [{ Name: args.sortCol.field, SortDirection: (args.sortAsc) ? 'Asc' : 'Desc' }];

            if (cWG.grid.options.enableLazyPageFetch) {
                cWG.grid.restricted.data = [];
                // this.loadUsingCurrentData();
            } else {
                // let sortDir = args.sortAsc ? 1 : -1; // Not being used?
                let sortCol = args.sortCol.field;

                let comparer = (a, b) => {
                    let x = a[sortCol], y = b[sortCol];

                    if (x === undefined) {
                        return y === undefined ? 0 : -1;
                    }

                    if (y === undefined) {
                        return 1;
                    }

                    return x === y ? 0 : ( x > y ? 1 : -1 );
                };

                // using native sort with comparer
                // preferred method but can be very slow in IE with huge datasets (alternative is to use dataView.fastSort
                // but it is lexical and won't properly handle numbers, dates, etc.)
                cWG.grid.restricted.dataView.sort(comparer, args.sortAsc);
                // cWG.grid.restricted.dataView.fastSort(sortCol, args.sortAsc);
            }
        });

        this.grid.columnpicker.onGroupChanged.subscribe((e, args) => {
            if (args.length) {
                // Grouping is buggy in paged mode, so let's eliminate paging when they want to group
                if (cWG.grid.restricted.dataView.getPagingInfo().pageSize !== 0) {
                    // This has the side effect of reloading the data if in lazy mode
                    cWG.grid.restricted.dataView.setPagingOptions({ pageSize: 0 });
                }
            }
        });

        this.grid.slickGrid.onClick.subscribe((e, args) => {
            let rowData = cWG.grid.getDataItem(args.row);
            if (cWG.options.onClick) {
                cWG.options.onClick(e, args, rowData);
            }
            if (cWG.options.onBtnClick) {
                if (e.target.id && e.target.id === 'renewBtn'){
                    console.log('btn click');
                    cWG.options.onBtnClick(e, args, rowData);
                }
            }
            console.log(e.target.id);
            
            
        });

        this.grid.slickGrid.onDblClick.subscribe((e, args) => {
            let rowData = cWG.grid.getDataItem(args.row);
            if (cWG.options.onDblClick) {
                // stop the grid from being edited
                cWG.options.completeGridEditDisabled = true;
                cWG.options.onDblClick(e, args, rowData);
            }
        });

        this.grid.slickGrid.onSelectedRowsChanged.subscribe((e, args) => {
            let rowData = cWG.grid.getDataItem(args.row);
            if (cWG.options.onSelectedRowsChanged) {
                cWG.options.onSelectedRowsChanged(e, args, rowData);
            }

            cWG.refreshSelection();
        });

        this.options.setData = (data) => {
            this.grid.setData(data);
        };

        this.options.autosizeColumns = () => {
            this.grid.slickGrid.autosizeColumns();
        };

        console.log(window.component);
        console.log(window);
        // this.grid.filterBar = this._er.nativeElement.querySelector('.grid-filter-bar');
    }

    startGrid() {
        let cWG = this;

        if (this.options === null) {
            throw 'Grid can not be initialized. Missing column information.';
        }

        this.hideHeader = !this.options.hideHeader;
        this.hideFooter = !this.options.hideFooter;

        this.grid.element = this._er.nativeElement.querySelector('.grid-container');
        this.grid.pagerElement = this._er.nativeElement.querySelector('.grid-footer');
        this.grid.headerElement = this._er.nativeElement.querySelector('.grid-header');
        this.grid.columns = this.options.columns;

        this.grid.height = this.options.height;
        this.grid.options.forceFitColumns = this.options.forceFitColumns;
        this.grid.options.completeGridEditDisabled = this.options.completeGridEditDisabled;
        if (this.options.primaryKey) {
            this.grid.options.primaryKey = this.options.primaryKey;
        }

        this.load();

        this.grid.buttons = [];

        if (this.options.showButtons) {
            if (this.canCreate) {
                this.grid.buttons.push({
                    label: 'Add',
                    action: () => {
                        cWG.add(null);
                    }
                });
            }

            if (this.canRead) {
                this.grid.buttons.push({
                    label: 'Refresh',
                    action: () => {
                        cWG.loadUsingCurrentData();
                    }
                });
            }

            if (this.canDelete) {
                this.grid.buttons.push({
                    label: 'Remove',
                    action: () => {
                        cWG.remove();
                    }
                });
            }

            if (this.canCreate || this.canUpdate) {
                this.grid.buttons.push({
                    label: 'Save',
                    action: () => {
                        cWG.save();
                    }
                });
            }
        }

        this.grid.show();

        if (this.options.data) {
            this.grid.setData(this.options.data);
        }
    }

    clearGroups() {
        this.grid.restricted.dataView.setGrouping([]);
        this.groups = [];
    }

    collapseGroups() {
        this.grid.restricted.dataView.collapseAllGroups();
    }

    expandGroups() {
        this.grid.restricted.dataView.expandAllGroups();
    }

    exportToCSV() {
        let exportData = [];
        // console.log(this.grid.restricted.dataView.getLength());
        for (let i = 0; i < this.grid.restricted.dataView.getLength(); i++) {
            // This is for the member checkout history grid, it has custom formatters on some of the columns
            if (this.grid.restricted.dataView.getItem(i).Items && 
            this.grid.restricted.dataView.getItem(i).Items[0].Title && 
            this.grid.restricted.dataView.getItem(i).Items[0].AssetType) {
                this.grid.restricted.dataView.getItem(i).Title = this.grid.restricted.dataView.getItem(i).Items[0].Title;
                this.grid.restricted.dataView.getItem(i).Type = this.grid.restricted.dataView.getItem(i).Items[0].AssetType;
            }
            exportData.push(this.grid.restricted.dataView.getItem(i));
        }
        // Using the typescript way of doing a for loop causes and error
        /*for ( let i in this.grid.restricted.dataView.getLength()) {
            console.log(i);
        }*/

        window.table2CSV({ grid: this.grid.slickGrid, loader: { data: exportData } });
    }

    add(newItem) {
        let item;

        if (this.options.defaultRow) {
            item = this.options.defaultRow();
        }

        this.grid.addDataItem(item);
        if (newItem) {
            Object.assign(item, newItem);
            this.grid.updateDataItem(item);
            this.grid.slickGrid.invalidate();
        }

        this.grid.slickGrid.setSelectedRows([item.mun - 1]);
    }

    remove() {

    }

    save() {
        this.batchMode = false;

        this.saveRestData();
    }

    load() {
        this.loadUsingCurrentData();
    }

    loadUsingCurrentData() {
        this.getRestData();
    }

    toggleGridForm() {
        this.gridFormVisible = !this.gridFormVisible;
    }

    refreshSelection() {
        if (!this.batchMode) {
            // let oldRow = this.editRow;

            this.selectedRows = this.grid.getSelectedRows();
            if (this.selectedRows.length === 1) {
                this.editRow = this.selectedRows[0];
            } else {
                this.editRow = null;
            }

            // let newRow = this.editRow;
        }
    }

    setData(data) {
        this.grid.setData(data);
        this.grid.recalculateHeight();
    }

    getRestData() { // Check to see if it is a custom route or not?
        if (this.options['title'] === undefined) {
            return;
        }

        if (this.options.disableRest) {
            return;
        }

         this._serviceStackService.Query(this.options['title'], null, null)
             .subscribe(
                 data => {
                     this.grid.setData(data.Results);
                     console.log(data);
                 },
                 error => this._toastr.error(error)
             );
    }

    saveRestData() {
        console.log(this.grid.restricted.dataView.dirtyItems);
        console.log(this.grid.restricted.dataView.deletes);
        /*if (this.grid.restricted.dataView.dirtyItems) {

        }*/
    }
}



// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/clearwave-grid/clearwave-grid.component.ts